import type { SelectItemProps } from "@radix-ui/react-select";
import * as Select from "@radix-ui/react-select";
import React from "react";

import { SELECT_ITEM_CLASS_NAME } from "./const";

export const SelectItem = React.forwardRef<HTMLDivElement, SelectItemProps>(({ children, ...props }, forwardedRef) => (
  <Select.Item className={SELECT_ITEM_CLASS_NAME()} {...props} ref={forwardedRef}>
    <Select.ItemText>{children}</Select.ItemText>
    <Select.ItemIndicator className="absolute left-0 inline-flex w-[25px] items-center justify-center"></Select.ItemIndicator>
  </Select.Item>
));

SelectItem.displayName = "SelectITem";
